<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Lista de Evaluaciones</h3>
			</div>
			<div class="card-body">
				<ListEvaluations :groupedEvaluations="evaluations.data || []"></ListEvaluations>                     				
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import request from '../../services/request'
import ListEvaluations from '../../component/evaluations/ListEvaluations.vue';

export default {
	name: "evaluations-list",
	components: {
		ListEvaluations
	},
	data() {
		return {
			profiles: {},
			evaluations: {},
		}
	},
	async mounted() {
		this.setHeaderTitle('Permisos');
		await this.evaluationsRequest()
	},
	created() {
		Event.$on("event-load-profiles", () => {
			this.list();
		});
	},
	methods: {
        async evaluationsRequest() {
			let service = request;
			let _endpoint = '/evaluations';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.evaluations = data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
		})
	}
}
</script>

<style scoped>

</style>
